import axios from 'axios';

export function searchAllUsers(text) {
  const params = new URLSearchParams();
  params.append("s", text);
  return axios.get('/admin/search/user', {
    params: params
  })
}

export function searchAllActiveUsers() {
  return axios.get('/admin/user')
}

export function searchUserQualifications(userId) {
  return axios.get(`/admin/user/${userId}/qualification`)
}

export function addQualification(userId, payload) {
  return axios.post(`/admin/user/${userId}/qualification`, payload);
}

export function deleteQualification(qualificationId) {
  return axios.delete( `/admin/qualification/${qualificationId}`);
}

export function getAreaLevels(areaId, issuerId) {
  return axios.get(`/admin/area/${areaId}/level?qualificationIssuerId=${issuerId}`)
}

export function searchProjectInContract(text) {
  return axios.get(`/admin/search/project/contract?s=${text}`)
}

export function searchProjectUsers(projectUserId) {
  return axios.get(`/admin/project/${projectUserId}/users`)
}

export function downloadContract(projectUserId) {
  return axios.get(`admin/project/${projectUserId}/contract`, {
    responseType: 'blob'
  })
}

export function deleteContract(projectUserId) {
  return axios.delete( `/admin/project/${projectUserId}/contract`);
}

export function uploadContract(projectUserId, file) {
  let formData = new FormData();
  formData.append('file', file);
  return axios.post( `/admin/project/${projectUserId}/contract/upload`,
      formData,
      {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      }
  )
}

export function updateQualifications(userId) {
  return axios.get(`/admin/user/${userId}/qualification/update`)
}

export function getAllProjects() {
  return axios.get(`/admin/project`)
}
export function getAllProjectUsers(projectId) {
  return axios.get(`/admin/project/${projectId}/projectUser`)
}

export function getAllAreas() {
  return axios.get(`/admin/area`);
}

export function getTasks() {
  return axios.get('/admin/tasks');
}

export function updateDeposit(projectId, value) {
  return axios.put(`/admin/project/${projectId}/deposit`, { value: value });
}

export function sendDepositEmails(projectUserId) {
  return axios.post(`/admin/project/${projectUserId}/deposit/email`);
}

export function getAllConfigs() {
  return axios.get(`/admin/config`);
}

export function updateConfig(configId, value) {
  return axios.put(`/admin/config/${configId}`, { value: value });
}
